<template>
  <div>
    <headers />

    <!-- <div class="breadcrumb" :key="itemKey">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>{{ "考试中心" }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div> -->
    <div class="content">
      <div class="contentScore">
        <div class="contentScoreTop">
          <span class="num">{{ displayScore }}</span>
          <span class="totalScoreSlash" v-if="result.totalScore"
            >/{{ result.totalScore }}</span
          >
          <span class="numText">分</span>
        </div>

        <div class="contentScoreResult">
          <div class="resTime">{{ times }}</div>
          <div class="resTimeText">考试用时</div>
          <div class="resType" :class="[result.state == 3 && 'resTypeErr']">
            {{ result.state == 2 ? "考试通过" : "考试未通过" }}
          </div>
        </div>
      </div>

      <div class="contentTiPs">
        {{
          result.state == 2
            ? "恭喜您通过考核，感谢您的参与！"
            : "很遗憾您未通过考核，不要气馁，再接再厉！"
        }}
      </div>
      <div class="dtBtn" @click="onClickSituation">查看答题情况</div>
      <div
        v-if="result.state != 2 || (result.state == 2 && showMaterialMenu)"
        class="contentBtn flexCenter"
        @click="onClicks"
      >
        {{ result.state == 2 ? "申请签约物资" : "重新考试" }}
      </div>
    </div>

    <openCode ref="openCode" />

    <footers />
  </div>
</template>

<script>
import headers from "@/components/header.vue";
import footers from "@/components/footer.vue";
import search from "@/components/search.vue";
import openCode from "@/components/openCode.vue";
import { userDetail } from "@/api/lx";
import { examSituation } from "@/api/examination";

export default {
  name: "examinationResult",
  components: {
    headers,
    footers,
    search,
    openCode,
  },
  data() {
    return {
      result: {},
      times: "",
      showMaterialMenu: false, // 是否显示物料申请按钮
    };
  },
  computed: {
    /**
     * 计算并格式化要显示的考试得分（包含补 0 处理）
     * @returns {string|number} 格式化后的得分
     */
    displayScore() {
      if (this.result.score === undefined || this.result.score === null) {
        return "00";
      }
      const scoreNum = Number(this.result.score) || 0;
      return scoreNum >= 10 ? scoreNum : "0" + scoreNum;
    },
  },
  beforeRouteUpdate(to, from, next) {
    next();
  },

  created() {
    this.result = this.$route.query || {};
    this.times = this.formatTime(this.result.useTime || 0);
    this.fetchUserDetail();
    this.fetchSituationIfNeeded();
    this.$root.$on("refreshUserInfo", this.fetchUserDetail);
  },
  beforeDestroy() {
    this.$root.$off("refreshUserInfo", this.fetchUserDetail);
  },
  mounted() {},
  methods: {
    /**
     * 若路由参数中缺少考试成绩相关数据（如得分为空、无总分或无状态），自动通过试卷 ID 发起接口请求补全所有成绩数据
     * 解决交卷接口报错 400 但后端已结算、路由未携带 score/state 时的回显问题
     * @returns {void}
     */
    fetchSituationIfNeeded() {
      if (this.result.id && (this.result.score === undefined || !this.result.totalScore || !this.result.state)) {
        examSituation({ id: this.result.id }).then((res) => {
          if (res && (res.code == 200 || res.code == 0 || res.success) && res.data) {
            this.$set(this.result, "totalScore", res.data.totalScore);
            this.$set(this.result, "score", res.data.score);
            this.$set(this.result, "state", res.data.state);
            this.$set(this.result, "useTime", res.data.useTime);
            this.times = this.formatTime(res.data.useTime || 0);
            this.fetchUserDetail();
          }
        });
      }
    },

    /**
     * 获取当前登录用户详情，决定是否显示签约物资申请按钮
     * @returns {void}
     */
    fetchUserDetail() {
      if (this.result.state == 2) {
        userDetail({})
          .then((res) => {
            if (res && res.data) {
              this.showMaterialMenu =
                res.data.showMaterialMenu === true ||
                res.data.showMaterialMenu === "true";
            }
          })
          .catch(() => {
            this.showMaterialMenu = false;
          });
      }
    },

    /**
     * 格式化考试用时秒数为“分秒”格式
     * @param {number} seconds - 总秒数
     * @returns {string} 格式化后的用时文本
     */
    formatTime(seconds) {
      if (!seconds) return "00分00秒";
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = seconds % 60;
      return `${minutes.toString().padStart(2, "0") + "分"}${
        secs.toString().padStart(2, "0") + "秒"
      }`;
    },
    /**
     * 重新考试或申请签约物料按钮点击事件函数
     * 当考试已通过（state==2）时唤起签约物料弹窗；未通过时，先弹出二次确认弹窗，确认后再跳转至试卷页面开启重新考试
     * @returns {void}
     */
    onClicks() {
      if (this.result.state == 2) {
        this.$refs.openCode.openShow();
      } else {
        this.$confirm("是否确认重新考试？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          confirmButtonClass: "custom-confirm-btn",
          type: "warning",
        })
          .then(() => {
            this.$router.replace({
              name: "examinationIndex",
              query: {
                taskId: this.result.taskId || "",
                id: this.result.id || "",
              },
            });
          })
          .catch(() => {});
      }
    },

    /**
     * 查看答题情况点击事件函数
     * 跳转答题详情页面展示试卷答题解析
     * @returns {void}
     */
    onClickSituation() {
      this.$router.push({
        name: "examinationSituation",
        query: {
          id: this.result.id,
          taskId: this.result.taskId || "",
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  width: 1400px;
  margin: 30px auto 40px;
  box-sizing: border-box;
  padding-left: 6px;
  padding-top: 120px;
  min-height: 684px;
  display: flex;
  //   flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #fff;
  .contentBtn {
    cursor: pointer;
    width: 380px;
    height: 55px;
    background: #00d8c3;
    border-radius: 4px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 18px;
    color: #ffffff;
  }
  .contentTiPs {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 17px;
    color: #00161a;
    line-height: 24px;
    text-align: center;
    font-style: normal;
    margin-bottom: 70px;
  }
  .contentScore {
    background: url("../../assets/images/resultBg.png");
    width: 214px;
    box-sizing: border-box;
    height: 214px;
    background-size: 100%;
    margin-bottom: 36px;
    padding-top: 36px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .contentScoreTop {
      .num {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 62px;
        color: #00d8c3;
        line-height: 87px;
        text-align: center;
        font-style: normal;
        padding-left: 20px;
      }
      .numText {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 16px;
        color: #00d8c3;
        line-height: 22px;
        font-style: normal;
        margin-left: 4px;
      }
      .totalText {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 13px;
        color: #829199;
        margin-left: 2px;
      }
    }

    .contentScoreResult {
      transform: translateY(-10px);
      .resTime {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #00161a;
        line-height: 22px;
        text-align: center;
      }
      .resTimeText {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #829199;
        line-height: 20px;
        text-align: center;
      }

      .resType {
        height: 32px;
        background: rgba(0, 216, 195, 0.1);
        border-radius: 16px;
        margin-top: 10px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 18px;
        color: #00d8c3;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .resTypeErr {
        width: 113px;
        background-color: rgba(209, 77, 33, 0.1);
        color: #d14d21;
      }
    }
  }
}
.dtBtn {
  font-size: 16px;
  color: #00d8c3;
  line-height: 20px;
  text-align: center;
  font-style: normal;
  cursor: pointer;
  margin-bottom: 20px;
  cursor: pointer;
}
</style>

<style lang="less">
.custom-confirm-btn {
  background-color: #00d8c3 !important;
  border-color: #00d8c3 !important;
  color: #ffffff !important;

  &:hover,
  &:focus,
  &:active {
    background-color: #00c4b0 !important;
    border-color: #00c4b0 !important;
    color: #ffffff !important;
  }
}
</style>
